import { comments } from '@/mocks/homeData';
import ImageBox from '@/components/base/ImageBox';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            网友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听吃瓜群众们怎么说
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <ImageBox
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0"
                  imgClassName="w-full h-full object-cover"
                />
                <div>
                  <h3 className="text-sm font-bold text-foreground-900 font-heading">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}